<template>
	<div class="dashboard_classification">
		<div class="main_div">
			<div class="tab_content">
				<ResultadosTab v-if="activeNavTab === TAB_IDS.RESULTADOS" />
				<VentasTab v-else-if="activeNavTab === TAB_IDS.VENTAS" />
				<CostosTab v-else-if="activeNavTab === TAB_IDS.COSTOS" />
				<GastosTab v-else-if="activeNavTab === TAB_IDS.GASTOS" />
				<RentabilidadTab v-else-if="activeNavTab === TAB_IDS.RENTABILIDAD" />
				<ActivosTab v-else-if="activeNavTab === TAB_IDS.ACTIVOS" />
				<NoOperTab v-else-if="activeNavTab === TAB_IDS.NO_OPER" />
				<ComingSoon v-else-if="activeNavTab === TAB_IDS.KPIS" label="KPIs" />
				<ComingSoon v-else-if="activeNavTab === TAB_IDS.PROYECCIONES" label="Proyecciones" />
			</div>
		</div>
	</div>
</template>

<script>
import ComingSoon from "@/components/layout/ComingSoon.vue";
import ResultadosTab from "./financialReports/tabs/ResultadosTab.vue";
import VentasTab from "./financialReports/tabs/VentasTab.vue";
import CostosTab from "./financialReports/tabs/CostosTab.vue";
import GastosTab from "./financialReports/tabs/GastosTab.vue";
import RentabilidadTab from "./financialReports/tabs/RentabilidadTab.vue";
import ActivosTab from "./financialReports/tabs/ActivosTab.vue";
import NoOperTab from "./financialReports/tabs/NoOperTab.vue";
import { TAB_IDS } from "./financialReports/config/tabs";

const VALID_TAB_IDS = Object.values(TAB_IDS);

export default {
	name: "DashboardReports",
	components: {
		ComingSoon,
		ResultadosTab,
		VentasTab,
		CostosTab,
		GastosTab,
		RentabilidadTab,
		ActivosTab,
		NoOperTab,
	},
	data() {
		return {
			activeNavTab: TAB_IDS.RESULTADOS,
			TAB_IDS,
		};
	},
	watch: {
		// El tab activo se controla 100% via $route.query.tab. La fuente de
		// navegación es el sub-menu del Sidebar (sección Reportes), que escribe
		// el tab al query. Default a RESULTADOS si el query es inválido/ausente.
		"$route.query.tab": {
			immediate: true,
			handler(newTab) {
				if (newTab && VALID_TAB_IDS.includes(newTab)) {
					this.activeNavTab = newTab;
				} else {
					this.activeNavTab = TAB_IDS.RESULTADOS;
				}
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.main_div {
	// El outer main.dashboard reserva var(--app-sidebar-w) para el rail;
	// acá sólo damos respiración de contenido al primer carácter.
	padding-left: clamp(16px, 2vw, 32px);
	padding-right: clamp(10px, 5.5vw, 93px);
	padding-bottom: 30px;
}

.tab_content {
	min-height: 400px;
}
</style>
